<template>
  <div class="page-landing">
    <div class="page-landing__banner" />

    <div class="page-landing__information">
      <div class="page-landing__content">
        <div class="content">
          <div class="content__block text">
            <h1>Hoeveel kost een makelaar?</h1>
          </div>

          <div class="content__block avg-prices block--shadow">
            <div class="avg-prices__indicator">
              <div class="avg-prices__percentages">
                <p class="avg-prices__percentages__value">
                  0.75<span class="percentages__unit">%</span>
                </p>
                <p class="avg-prices__percentages__value">
                  2<span class="avg-prices__percentages__unit">%</span>
                </p>
              </div>

              <div class="avg-prices__bar" />
            </div>
            <p class="avg-prices__text">
              Gemiddeld rekenen makelaars tussen de
              <strong>0,75% en 2%</strong> van de totale prijs van een woning
              als courtage. Dit betekent dat je voor een woning van €300.000
              tussen <strong>€2.250 tot €6.000</strong> aan makelaarskosten
              betaalt.
            </p>
          </div>

          <div class="content__block text">
            <p>
              De meeste kosten, belastingen en vergoedingen die bij de verkoop
              van een woning gemaakt worden worden door de koper betaald. Echter
              de courtage kosten worden door de verkopende partij betaald.
            </p>
          </div>

          <div class="content__block agents-amount block--center">
            <h2>Wist je dat?</h2>
            <p class="agents-amount__counter">+10.200</p>
            <p class="agents-amount__counter-unit">
              aantal makelaars in Nederland
            </p>
          </div>

          <div class="content__block text">
            <p>
              In Nederland zijn
              <strong>meer dan 10.000 makelaars werkzaam</strong>. Hoe kies je
              de juiste voor jou? Dat is waar Makelaarwijzer.nl je bij kan
              helpen. We hebben de beste makelaars al in kaart gebracht en
              matchen je met degene die het beste past bij wat je zoekt, met
              kennis en ervaring in jouw regio.
            </p>
          </div>
        </div>
      </div>

      <div class="page-landing__content page-landing__content--bg-color">
        <div class="content">
          <div class="content__block cta block--padding block--center">
            <h3 class="text--blue">
              Vind dé beste makelaar in jouw regio en bespaar nu
            </h3>

            <div class="postal-form-step-container">
              <PostalFormStep :progress-value="0" />
            </div>
          </div>
        </div>
      </div>

      <div class="page-landing__content">
        <div class="content content--spacing-sm">
          <div class="content__block text">
            <h3>Soorten makelaarskosten</h3>
            <p>Er zijn 2 manieren waarop een makelaar zijn kosten berekent.</p>
          </div>

          <div class="content__block text">
            <h5>Vaste vergoeding</h5>
            <p>
              Dit is een vooraf bepaald bedrag waarmee je akkoord gaat om de
              makelaar te betalen voor hun diensten. Deze methode heeft over het
              algemeen de voorkeur van mensen die een huis kopen, omdat de
              waarde die aan de makelaar moet worden betaald vooraf bekend is,
              waardoor latere verrassingen worden voorkomen.
            </p>
          </div>

          <div class="content__block text">
            <h5>Vaste Courtage</h5>
            <p>
              Bij een op courtage gebaseerde deal zal de makelaar je een vooraf
              bepaald percentage van de totale aankoopprijs van de woning in
              rekening brengen. Deze optie is het meest gekozen wanneer je een
              huis verkoopt, omdat de makelaar zal proberen de beste waarde voor
              jouw eigendom te krijgen, waardoor meer geld voor jou en voor hen
              wordt verdiend.
            </p>
          </div>

          <div
            class="content__block pro-tip block--padding-small rounded-lg block--shadow"
          >
            <h6>Pro tip</h6>
            <p>
              Het kan ook interessant zijn om een bonus fee af te spreken met
              jouw makelaar, gebaseerd op het bedrag dat zij je kunnen besparen
              (bij het kopen van een woning) of voor je verdienen (bij het
              verkopen van een huis).
            </p>
          </div>

          <div class="content__block text">
            <h5>Locatie en staat van onderhoud kunnen het verschil maken</h5>
            <p>
              Als een woning zich in een gebied met een grote vraag bevindt,
              kunnen makelaars je een lagere vergoeding vragen voor hun
              diensten. Dit omdat het waarschijnlijker is dat er relatief snel
              een deal wordt gesloten, waardoor ze tijd besparen. Hetzelfde
              geldt voor de waarde en staat van de woning: hoe beter de woning,
              hoe groter de kans dat deze sneller wordt verkocht.
            </p>
          </div>

          <div class="content__block text">
            <h5>Waarom je makelaars zou moeten vergelijken</h5>
            <p>
              Bij het zoeken naar de beste makelaar zijn er een aantal zaken
              waarmee je rekening dient te houden:
            </p>
            <ul>
              <li>Is de makelaar een expert in jouw regio?</li>
              <li>Hoeveel kosten zullen ze berekenen voor hun diensten?</li>
              <li>Wat zijn de diensten die ze voor je gaan leveren?</li>
            </ul>
          </div>

          <div class="content__block savings block--shadow rounded-lg">
            <div class="savings__amount">
              <p class="savings__amount__value">40%</p>
            </div>

            <p>
              Dat is hoeveel je kunt
              <strong>besparen op makelaarskosten</strong> door offertes van
              verschillende makelaars te vergelijken en te onderhandelen over
              een deal die het beste bij jou past.
            </p>
          </div>

          <div class="content__block text">
            <p>
              Op <strong>Makelaarwijzer</strong> hebben we al de beste en meest
              betrouwbare makelaars van Nederland in kaart gebracht, en kunnen
              we je doorverwijzen naar makelaars met kennis en expertise in jouw
              regio.
            </p>
          </div>

          <div
            class="content__block cta block--padding block--center block--rounded block--shadow"
          >
            <h3>Vind dé beste makelaar in jouw regio</h3>

            <div class="postal-form-step-container">
              <PostalFormStep :progress-value="0" />
            </div>
          </div>

          <div class="content__block usps-container block--no-text-styling">
            <Usps :usps="usps" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import Usps from 'chimera/all/themes/blueflow/components/Usps'
import PostalFormStep from '~/components/form/steps/postal/PostalFormStep'

export default {
  components: {
    PostalFormStep,
    Usps,
  },

  extends: AbstractPage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Op zoek naar een makelaar?',
      headDescription:
        'Binnenkort je huis verkopen? Door makelaars te vergelijken is het mogelijk om de beste makelaar te vinden die qua service en kosten volledig bij je past.',
      path: '/lp/makelaarskosten',
      usps: [
        {
          title: 'Beantwoord een paar vragen',
          text: 'Je vertelt ons wat je zoekt, hierdoor kunnen wij de juiste makelaar uit jouw regio aan jou koppelen.',
          logo: require('chimera/all/themes/blueflow/images/usps/pencil.svg'),
        },
        {
          title: 'Ontvang gratis offertes',
          text: 'Je ontvangt maximaal zes offertes van makelaars die aan je behoeften voldoen. Hiermee bespaar je tot 40%!',
          logo: require('chimera/all/themes/blueflow/images/usps/offer.svg'),
        },
        {
          title: 'Kies de juiste makelaar',
          text: 'Wij hebben onze makelaars al gecheckt, je hoeft alleen maar de offertes te vergelijken en te kiezen.',
          logo: require('chimera/all/themes/blueflow/images/usps/user.svg'),
        },
      ],
    }
  },
}
</script>
